import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";

const ICON = { trophy: "Trophy", flame: "Flame", zap: "Zap", star: "Star", timer: "Timer", globe: "Globe", medal: "Medal", crown: "Crown" };

export default function Achievements() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/game/achievements").then(({ data }) => setItems(data.achievements)).catch(() => {});
  }, [user, authLoading, navigate]);

  const unlocked = items.filter((i) => i.unlocked).length;

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
        <p className="font-mono-caps text-xs text-primary mb-3">Progress</p>
        <h1 className="font-display text-5xl mb-2">BADGES</h1>
        <p className="font-mono-caps text-[10px] text-muted-foreground mb-10">{unlocked} / {items.length} unlocked</p>

        <div className="grid sm:grid-cols-2 gap-4">
          {items.map((a) => {
            const Icon = Icons[ICON[a.icon]] || Icons.Award;
            return (
              <div key={a.key} data-testid={`achievement-${a.key}`}
                className={`border p-5 flex items-center gap-4 transition-colors ${a.unlocked ? "border-primary bg-primary/5" : "border-white/10 bg-card opacity-60"}`}>
                <div className={`w-12 h-12 flex items-center justify-center border ${a.unlocked ? "border-primary text-primary" : "border-white/15 text-muted-foreground"}`}>
                  <Icon size={22} />
                </div>
                <div>
                  <h3 className="font-display text-xl">{a.name}</h3>
                  <p className="text-sm text-muted-foreground">{a.description}</p>
                  {a.unlocked && <p className="font-mono-caps text-[8px] text-primary mt-1">Unlocked</p>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
